import { useState, useCallback } from 'react';

const KEY = 'gs_hub_pins';
const MAX_PINS = 4;

export function usePins() {
  const [pins, setPins] = useState<string[]>(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]') as string[];
    } catch {
      return [];
    }
  });

  const persist = (next: string[]) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* ignore */
    }
    setPins(next);
  };

  const pin = useCallback((id: string) => {
    setPins((prev) => {
      if (prev.includes(id)) return prev;
      if (prev.length >= MAX_PINS) return prev; // max atteint
      const next = [...prev, id];
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const unpin = useCallback((id: string) => {
    persist(pins.filter((p) => p !== id));
  }, [pins]);

  const togglePin = useCallback((id: string) => {
    setPins((prev) => {
      const isPinned = prev.includes(id);
      const next = isPinned ? prev.filter((p) => p !== id) : prev.length < MAX_PINS ? [...prev, id] : prev;
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const isPinned = (id: string) => pins.includes(id);
  const canPin = pins.length < MAX_PINS;

  return { pins, pin, unpin, togglePin, isPinned, canPin };
}
